import { axiosInstance, handleAxiosResponse } from "../../../core/sources/network";
import { handleError, showSuccess } from "../../app-messages";

export const verifyResetPasswordToken = ({ email, token }) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get("/authentication/password-reset/token", { params: { email, token } });

      const { message } = handleAxiosResponse(response);

      dispatch(showSuccess(message));
    } catch (error) {
      handleError(error?.response?.data?.message ?? error.message)(dispatch);
    }
  };
};
